var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"pa-3"},[_c('h4',{staticClass:"font-weight-bold mt-5 cyan--text text--darken-2"},[_c('v-icon',[_vm._v("mdi-star-four-points")]),_vm._v(" این بخش در حال توسعه می‌باشد، از صبر و شکیبایی شما سپاس‌گزاریم. ")],1),_c('img',{staticClass:"float-end",attrs:{"src":"/comingSoon.gif"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }